/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountActiveTrialQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountActiveTrialQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isTrialBarDisplayed: boolean, readonly trialExpirationDate: CK.Timestamp | null } | null };


export const AccountActiveTrialDocument = gql`
    query AccountActiveTrial($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isTrialBarDisplayed
    trialExpirationDate
  }
}
    `;

/**
 * __useAccountActiveTrialQuery__
 *
 * To run a query within a React component, call `useAccountActiveTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountActiveTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountActiveTrialQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountActiveTrialQuery(baseOptions: Apollo.QueryHookOptions<AccountActiveTrialQuery, AccountActiveTrialQueryVariables> & ({ variables: AccountActiveTrialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>(AccountActiveTrialDocument, options);
      }
export function useAccountActiveTrialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>(AccountActiveTrialDocument, options);
        }
export function useAccountActiveTrialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>(AccountActiveTrialDocument, options);
        }
export type AccountActiveTrialQueryHookResult = ReturnType<typeof useAccountActiveTrialQuery>;
export type AccountActiveTrialLazyQueryHookResult = ReturnType<typeof useAccountActiveTrialLazyQuery>;
export type AccountActiveTrialSuspenseQueryHookResult = ReturnType<typeof useAccountActiveTrialSuspenseQuery>;
export type AccountActiveTrialQueryResult = Apollo.QueryResult<AccountActiveTrialQuery, AccountActiveTrialQueryVariables>;